// This directive is fixing weird safari bug: https://github.com/facebook/react/issues/22684

import type { Directive, DirectiveBinding } from 'vue';

export const imageSrcDirective: Directive = {
  beforeMount(el: HTMLElement, { value }: DirectiveBinding) {
    el.setAttribute('src', value);
  },
};
